// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#loadingScreen{
    position: absolute;
    top: 0;
    left: 0;
	bottom: 0;
	right: 0;
    width: 100%;
    height: 100%;
    z-index: 150000;
    background: #00000087;
    display: flex;
    justify-content: center;
    align-items: center;
}


#loadingScreen[data-open="true"] #leftDoor{
    display: flex;
    animation-name: leftDoorAnimation;
    animation-duration: 1.5s;
    animation-fill-mode: forwards;
    animation-iteration-count: 10000;
}
#loadingScreen[data-open="true"] #rightDoor{
    display: flex;
    animation-name: rightDoorAnimation;
    animation-duration: 1.5s;
    animation-fill-mode: forwards;
    animation-iteration-count: 10000;
}

#loadingScreenContainer{
    display: flex;
    height: 35px;
}

#loadingScreenDoors{
    width: 125px;
    position: relative;
}

#leftWall,#leftDoor,#rightDoor,#rightWall{
    margin: -7px;
    position: absolute;
    left: 0;
}

#leftWall{

}

#leftDoor{
    left: 25px;
}

#rightDoor{
    left: 50px;
}

#rightWall{
    left: 75px;
}

@keyframes leftDoorAnimation {
    from { left: 25px; }
    to { left: 0px; }
}

@keyframes rightDoorAnimation {
    from { left: 50px; }
    to { left: 75px; }
}`, "",{"version":3,"sources":["webpack://./src/project/modules/loading/loading.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;CACV,SAAS;CACT,QAAQ;IACL,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,iCAAiC;IACjC,wBAAwB;IACxB,6BAA6B;IAC7B,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,kCAAkC;IAClC,wBAAwB;IACxB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;AACX;;AAEA;;AAEA;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,SAAS,EAAE;AACpB;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB","sourcesContent":["#loadingScreen{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n\tbottom: 0;\r\n\tright: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 150000;\r\n    background: #00000087;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n\r\n#loadingScreen[data-open=\"true\"] #leftDoor{\r\n    display: flex;\r\n    animation-name: leftDoorAnimation;\r\n    animation-duration: 1.5s;\r\n    animation-fill-mode: forwards;\r\n    animation-iteration-count: 10000;\r\n}\r\n#loadingScreen[data-open=\"true\"] #rightDoor{\r\n    display: flex;\r\n    animation-name: rightDoorAnimation;\r\n    animation-duration: 1.5s;\r\n    animation-fill-mode: forwards;\r\n    animation-iteration-count: 10000;\r\n}\r\n\r\n#loadingScreenContainer{\r\n    display: flex;\r\n    height: 35px;\r\n}\r\n\r\n#loadingScreenDoors{\r\n    width: 125px;\r\n    position: relative;\r\n}\r\n\r\n#leftWall,#leftDoor,#rightDoor,#rightWall{\r\n    margin: -7px;\r\n    position: absolute;\r\n    left: 0;\r\n}\r\n\r\n#leftWall{\r\n\r\n}\r\n\r\n#leftDoor{\r\n    left: 25px;\r\n}\r\n\r\n#rightDoor{\r\n    left: 50px;\r\n}\r\n\r\n#rightWall{\r\n    left: 75px;\r\n}\r\n\r\n@keyframes leftDoorAnimation {\r\n    from { left: 25px; }\r\n    to { left: 0px; }\r\n}\r\n\r\n@keyframes rightDoorAnimation {\r\n    from { left: 50px; }\r\n    to { left: 75px; }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
